import { render, staticRenderFns } from "./CreateTrigger.vue?vue&type=template&id=547b199c"
import script from "./CreateTrigger.vue?vue&type=script&lang=js"
export * from "./CreateTrigger.vue?vue&type=script&lang=js"
import style0 from "./CreateTrigger.vue?vue&type=style&index=0&id=547b199c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports